module.exports = __webpack_public_path__ + "static/img/96.1bb3f23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/96.png
// module id = 7iiL
// module chunks = 0